import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';

import { useStudentMediaStats } from 'modules/media/hooks/stats';
import { useStudent } from 'modules/students/hooks';

import StudentMediaStatsTable from 'modules/media/components/StudentMediaStatsTable';

const StudentMediaStatsPage = () => {
  const history = useHistory();
  const intl = useIntl();
  const { courseId, studentId } = useParams<{ courseId: string; studentId: string }>();
  const { mediaStats, loading, error, onFetchStats, onFilterStats, onGetXlsxData } = useStudentMediaStats({ courseId, studentId });
  const { student } = useStudent({ courseId, studentId });

  const onClickMediaItem = useCallback(
    (mediaItem) => {
      history.push(`/${courseId}/students/${studentId}/media-stats/${mediaItem._id}?from=/${courseId}/students/${studentId}/media-stats`);
    },
    [history, courseId, studentId]
  );

  return (
    <StudentMediaStatsTable
      mediaStats={mediaStats}
      loading={loading}
      error={error}
      student={student}
      onFetchStats={onFetchStats}
      onFilterStats={onFilterStats}
      onClickMediaItem={onClickMediaItem}
      onGetXlsxData={onGetXlsxData}
      xlsxFileName={`${student?.name} - ${intl.formatMessage({
        id: 'courseMediaStatsTable.title',
      })}`}
    />
  );
};

export default StudentMediaStatsPage;
